/**
 * BESTIX v5.0 — Section Header
 * Editorial-style section headers with decorative lines
 */

import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  decorated?: boolean;
  action?: { label: string; href: string };
  className?: string;
}

export function SectionHeader({
  title,
  subtitle,
  align = 'center',
  decorated = true,
  action,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn('mb-10', align === 'center' ? 'text-center' : 'text-left', className)}>
      {decorated && (
        <div className={cn('w-16 h-px bg-[var(--color-navy)] mb-6', align === 'center' && 'mx-auto')} />
      )}

      <div className={cn(
        'flex items-center gap-4',
        align === 'center' ? 'justify-center' : 'justify-between'
      )}>
        <h2 className="font-playfair italic text-3xl md:text-4xl text-[var(--color-navy)]">{title}</h2>
        {action && align === 'left' && (
          <Link 
            to={action.href} 
            className="text-sm text-[var(--color-gold)] hover:text-[var(--color-gold-dark)] font-medium flex items-center gap-1"
          >
            {action.label}
            <ChevronRight className="w-4 h-4" />
          </Link>
        )}
      </div>

      {subtitle && <p className="text-gray-500 mt-2 text-lg">{subtitle}</p>}

      {decorated && (
        <div className={cn('w-16 h-px bg-[var(--color-navy)] mt-6', align === 'center' && 'mx-auto')} />
      )}

      {action && align === 'center' && (
        <Link 
          to={action.href} 
          className="inline-flex items-center gap-1 mt-6 text-sm text-[var(--color-gold)] hover:text-[var(--color-gold-dark)] font-medium"
        >
          {action.label}
          <ChevronRight className="w-4 h-4" />
        </Link>
      )}
    </div>
  );
}

export default SectionHeader;
